/**
 * ЭТАП 3 п.3 — СТАРЫЙ ЧИСЛОВОЙ АДРЕС МАГАЗИНА: 301 на человеческий.
 *
 * В проде это делал `lib/routes/shop.ts`: `/shop/123` -> 301 на
 * `/shop-<identify>`, а если магазина с таким id нет — 301 на `/shop`.
 * У нас маршрута `/shop/:id` не было вовсе, то есть старая форма адреса
 * отдавала 404 и весь накопленный по ней вес просто терялся. Разбор — в
 * `docs/SSR_LAZARSERVER_AUDIT.md`, п.5.
 *
 * КАК ИЩЕМ МАГАЗИН. Отдельного метода «магазин по id» у бэка нет — как и на
 * `/shop-:shopId`, перебираем общий список `getShops` (там есть и `id`, и
 * `identify`). Список кэшируется на 10 минут и всё равно нужен другим
 * страницам, так что своего запроса это не добавляет.
 *
 * Нечисловой хвост (`/shop/abc`) — 404: в проде под числовой формат стоял
 * regex-роут `/shop/:id(\d+)`, а всё остальное падало в общий 404.
 */
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { getQueryClient } from '../../providers/query';
import { shopsQueryOptions } from '@queries/shops';

export const Route = createFileRoute('/shop/$id')({
  loader: async ({ params }) => {
    if (!/^\d+$/.test(params.id)) {
      throw notFound();
    }
    // Клиентскую навигацию тут НЕ пропускаем (в отличие от честных 404):
    // у роута нет своей разметки — он целиком про редирект, и без него
    // SPA-переход на /shop/123 показал бы пустую страницу
    const queryClient = getQueryClient();
    let data;
    try {
      data = await queryClient.ensureQueryData(shopsQueryOptions());
    } catch {
      // Сетевой сбой — не повод отдавать редирект в никуда
      return;
    }
    const shop = (data?.getShops ?? []).find(
      item => `${item?.id}` === params.id
    );
    // Как в проде: неизвестный id склеиваем с общим лендингом, а не 404-м —
    // адрес был живым и мог накопить ссылки
    throw redirect({
      to: shop?.identify ? `/shop-${shop.identify}` : '/shop',
      statusCode: 301
    });
  },
  // Сюда не доходим: лоадер всегда бросает redirect или notFound. Компонент
  // нужен только чтобы роут был валидным.
  component: () => null
});
